import React from 'react';
import * as stickyButtonStyle from '../../styles/internal-page/sticky-button.module.scss';
import PolyLink from '../shared/PolyLink';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const StickyButton = ({ elem }) => {
  const { buttonContent, url, target, ariaLabel, buttonColor } = elem;
  return (
    <div className={stickyButtonStyle.container}>
      <div className={clsx(stickyButtonStyle.button, {[stickyButtonStyle.red]: buttonColor === 'RED', [stickyButtonStyle.white]: buttonColor === 'WHITE', [stickyButtonStyle.black]: buttonColor === 'BLACK'})}>
        <PolyLink ariaLabel={ariaLabel}
          target={target}
          url={url}
        >
          <p className={stickyButtonStyle.content}>
            {buttonContent}
          </p>
        </PolyLink>
      </div>
    </div>
  );
};

StickyButton.propTypes = {
  elem: PropTypes.shape({
    buttonColor: PropTypes.oneOf(['RED', 'BLACK', 'WHITE']),
    buttonContent: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    target: PropTypes.string,
    ariaLabel: PropTypes.string
  }).isRequired
};

export default StickyButton;